import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=dd4b7d1a&scoped=true&"
import script from "./orderList.ts?vue&type=script&lang=ts&"
export * from "./orderList.ts?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=dd4b7d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4b7d1a",
  null
  
)

export default component.exports